import { stripCid } from "@libs/rudderstack/cid";
import { useAuth } from "@utils/firebaseAuth/auth";
import { router } from "expo-router";
import { useEffect } from "react";
import { useLandingStore } from "store/useLandingStore";

const InternalComponent = () => {
  const { status, onboardingStep } = useAuth();
  const deepLink = useLandingStore((state) => state.deepLink);
  const queuedDeepLink = useLandingStore((state) => state.queuedDeepLink);

  // Queue or navigate incoming deep links
  useEffect(() => {
    if (!deepLink) return;

    // During onboarding, queue the link instead of navigating
    if (
      status === "logged-in" &&
      onboardingStep &&
      onboardingStep !== "completed"
    ) {
      useLandingStore.setState({
        queuedDeepLink: deepLink,
        deepLink: undefined,
      });
      return;
    }

    useLandingStore.setState({ deepLink: undefined });
    // A Branch-resolved deep link can carry ?cid; strip it before it reaches
    // the address bar — the landing/param ingests already recorded it.
    router.navigate(stripCid(deepLink as string), { withAnchor: true });
  }, [deepLink, status, onboardingStep]);

  // Navigate to queued link when onboarding completes
  useEffect(() => {
    if (onboardingStep !== "completed" || !queuedDeepLink) return;

    useLandingStore.setState({ queuedDeepLink: undefined });
    router.navigate(stripCid(queuedDeepLink as string), { withAnchor: true });
  }, [onboardingStep, queuedDeepLink]);

  return null;
};

const DeepLinkHandler = () => {
  return <InternalComponent />;
};

export default DeepLinkHandler;
